import { useEffect, useState } from "react";
import { MapOverlayWidget } from "../../../../widgets/map/mapAddons/mapOverlayWidget";
import { getAllRoadObjectsLayer, getWKTFeatureVectorLayer } from "../../../../widgets/map/mapFeatures/layers";
import MapWidget from "../../../../widgets/map/mapWidget/MapWidget";
import { useDispatch } from "react-redux";
import { useFetchTransportDrivewaysListQuery } from "../../../../api/rtk/base/slices/transportApiSlice";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { setTransportHistoryChosenDate, setTransportHistoryChosenDriveways, setTransportHistoryCurrentTransportDates, setTransportHistoryCurrentTransportDriveways, setTransportHistoryCurrentTransportId, setTransportHistoryDrivewaysList } from "../../../../stateManagement/reducers/transport/TransportHistorySlice";
import { convertDate } from "../../../../features/dataFormatFunctions/dataFormatter";
import LoaderWrapper from "../../../../widgets/loaderWrapper/LoaderWrapper";
import { countExtentFromWKTFeatures } from "../../../../widgets/map/mapFeatures/helpers";
import { getColorBackgroundStyle } from "../../../../widgets/map/mapFeatures/styles/mapStyles";
import ContentHeader from "../../../../widgets/contentHeader/ContentHeader";
import { showToastMessage } from "../../../../stateManagement/reducers";
import ToastMessageContainer from "../../../../widgets/toastMessageContainer/ToastMessageContainer";

export function MapTransportHistory() {
    const dispatch = useDispatch()
    const objectTypeName = "TransportHistory"
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const [fitExtent, setFitExtent] = useState<any>();
    const [fitExtentPadding, setFitExtentPadding] = useState<any>([]);
    const { transportHistoryChosenDriveways, transportHistoryShowOnMapButtonClicked } = useAppSelector(state => state.transportHistory)

    const roadsLayer = getAllRoadObjectsLayer()
    const [permanentLayers] = useState([roadsLayer])

    const { data: drivewaysList, isFetching: isFetchingDrivewaysList, isError: isErrorDrivewaysList } = useFetchTransportDrivewaysListQuery({})

    const chosenDate = useAppSelector(state => state.transportHistory.transportHistoryChosenDate)
    const currentTransportDriveways = useAppSelector(state => state.transportHistory.transportHistoryCurrentTransportDriveways)
    const currentTransportId = useAppSelector(state => state.transportHistory.transportHistoryCurrentTransportId)

    useEffect(() => {
        if (Array.isArray(drivewaysList)) {
            dispatch(setTransportHistoryDrivewaysList(drivewaysList))
            dispatch(setTransportHistoryCurrentTransportId(drivewaysList[0]?.id))
            let datesForSort = [...drivewaysList[0]?.dates]
            let sortedDates = datesForSort.sort(function (a: any, b: any) {
                a = new Date(a)
                b = new Date(b)
                return a - b;
            });
            dispatch(setTransportHistoryChosenDate(convertDate(sortedDates[0])))
            dispatch(setTransportHistoryCurrentTransportDriveways(drivewaysList[0]?.driveways))
            let datesObjects = sortedDates.map((date: any) => {
                let dateWithoutTime = date.split(' ')[0];
                let splitDateWithoutTime = dateWithoutTime.split('-')
                let day = splitDateWithoutTime[2].replace(/^0+/, '')
                let month = splitDateWithoutTime[1].replace(/^0+/, '')
                let year = splitDateWithoutTime[0].replace(/^0+/, '')
                return { day, month, year }
            })
            dispatch(setTransportHistoryCurrentTransportDates(datesObjects))
        }
    }, [drivewaysList])

    useEffect(() => {
        let chosenDrivewaysObjects = currentTransportDriveways && currentTransportDriveways.filter((item: any) => {
            let shortDates = item.dates && item.dates.map((date: any) => date.split(' ')[0])
            return shortDates.includes(chosenDate)
        })
        let chosenDriveways = chosenDrivewaysObjects && chosenDrivewaysObjects.map((item: any) => item?.wkt)
        dispatch(setTransportHistoryChosenDriveways(chosenDriveways))
    }, [chosenDate, currentTransportId])

    useEffect(() => {
        if (transportHistoryChosenDriveways) {
            const transportDrivewayLayerBackground = getWKTFeatureVectorLayer(transportHistoryChosenDriveways, getColorBackgroundStyle("#fff", 6))
            const transportDrivewayLayer = getWKTFeatureVectorLayer(transportHistoryChosenDriveways)
            setAdditionalLayers([transportDrivewayLayerBackground, transportDrivewayLayer])
            const extent = countExtentFromWKTFeatures(transportHistoryChosenDriveways)
            setFitExtent(extent)
            setFitExtentPadding([350, 350, 350, 350])
        }
    }, [transportHistoryChosenDriveways, transportHistoryShowOnMapButtonClicked])

    useEffect(() => {
        if (isErrorDrivewaysList) {
            dispatch(showToastMessage({ messageText: "Не удалось историю движения транспорта", messageType: "error" }))
        }
    }, [isErrorDrivewaysList])

    return (
        <>
            <ContentHeader title="Карта «Транспортные средства на дороге»" objectTypeName={objectTypeName} type="map" />
            <div className="map-transport-history-div">
                <div className="map-widget-with-toast near-overlay">
                    <ToastMessageContainer />
                    <LoaderWrapper isLoading={isFetchingDrivewaysList} >
                        <MapWidget additionalLayers={additionalLayers} permanentLayers={permanentLayers} propsFitExtent={fitExtent} propsFitExtentPadding={fitExtentPadding} />
                    </LoaderWrapper>
                </div>
                <MapOverlayWidget />
            </div>
        </>
    )
}
